import React from 'react';

import { UpsellSection } from 'features/cart/components/cart-content/upsell-section';
import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { Upsell } from 'pages/cart/upsell';

export const ProductUpsell: React.FC = () => {
  const enableMinimalCartUi = useMinimalCartUi();
  if (enableMinimalCartUi) {
    return (
      <UpsellCarouselWrapper>
        <UpsellSection />
      </UpsellCarouselWrapper>
    );
  }
  return (
    <UpsellCarouselWrapper>
      <Upsell />
    </UpsellCarouselWrapper>
  );
};

const UpsellCarouselWrapper = ({ children }: React.PropsWithChildren) => (
  <Box style={styles.upsellCarouselWrapper}>{children}</Box>
);

const styles = StyleSheet.create({
  upsellCarouselWrapper: {
    marginHorizontal: 16,
  },
});
